import React, { Component } from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from 'Axios';
import Avatar from 'Avatar';
import { Cancel, MailSharp } from '@material-ui/icons';
import { Tooltip, Grid } from '@material-ui/core';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 200px;
`;

const User = styled.div`
  padding: 12px 8px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  border-radius: 4px;
  width: 100%;

  &:hover {
    background: #c5c6c5;
  }
`;

const UserInfo = styled.div`
  padding-left: 12px;
  flex: 1;
  text-align: left;

  p {
    font-weight: bold;
    color: #37474e;
    font-size: 18px;
    margin-bottom: 4px;
  }

  span {
    color: #787999;
    font-size: 15px;
  }
`;

const UserStatus = styled.div`
  width: 100px;
`;

const StatusLabel = styled.div`
  margin-bottom: 4px;
  font-weight: bold;
  font-size: 14px;
  color: ${props => {
    switch (props.status) {
      case 'ACTIVE':
        return '#4CAF50';
      case 'DEACTIVATED':
        return '#F44336';
      case 'INVITED':
        return "#c79a00";
      default:
        return '#000';
    }
  }};
`;

const StatusBtn = styled(Button)`
  width: 100px;
`;

export default class RepsAndTraders extends Component {
  state = {
    users: [],
    loading: true,
    cancelInviteRefresh: false
  };

  componentDidUpdate(prevProps, prevState) {
    const { companyId, refresh } = this.props;
    if (companyId && (companyId !== prevProps.companyId || (refresh && !prevProps.refresh) || (this.state.cancelInviteRefresh && !prevState.cancelInviteRefresh))) {
      axios
        .get(`/company/${companyId}/reps_and_traders`)
        .then(response => {
          if (response.data) {
            this.setState({ users: response.data });
          }
          this.setState({ 
            cancelInviteRefresh: false,
            loading: false 
          });
        })
        .catch(error => {
          this.props.showSnackbar(
            'Unable to load list of of invited company users'
          );
          this.setState({ 
            cancelInviteRefresh: false,
            loading: false 
          });
        });
    }
  }

  toggleUserStatus = userId => () => {
    // TODO: this shouldn't be done with a get request, change on BE
    this.setState({ submitting: true });
    axios
      .get(`/admin/users/${this.props.companyId}/${userId}/deactivate`)
      .then(response => {
        if (response.status === 200) {
          this.setState(prevState => {
            return {
              submitting: false,
              users: prevState.users.map(user => {
                if (user.id === userId) {
                  user.state =
                    user.state === 'DEACTIVATED' ? 'ACTIVE' : 'DEACTIVATED';
                }
                return user;
              }),
            };
          });
        }
      })
      .catch(error => {
        this.showSnackbar('Unable to change user status');
        this.setState({ submitting: false });
      });
  };

  sendReminder = (companyId, invitationId) => () => {
    axios
      .post('company/' + companyId + '/invite/' + invitationId + '/resend')
      .then(response => {
        this.props.showSnackbar(
          'The reminder email has been sent',
        );
        this.setState({ 
          loading: false 
        });
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        this.props.showSnackbar(errorMessage);
        this.setState({ loading: false });
      });
  };

  deleteInvitation = (companyId, invitationId) => () => {
    axios
      .delete('company/' + companyId + '/invite/' + invitationId)
      .then(response => {
        this.props.showSnackbar(
          'The invitation has been canceled',
        );
        this.setState({ 
          cancelInviteRefresh: true, 
          loading: false 
        });
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        this.props.showSnackbar(errorMessage);
        this.setState({ 
          cancelInviteRefresh: false, 
          loading: false 
        });
      });
  };

  renderUsers = () =>
    this.state.users.map(user => (
      <User key={user.id}>
        <Avatar user={user} imageId={user.profileAssetId} />
        <UserInfo>
          <p style={{ overflowWrap: 'anywhere' }} >
            {user.firstName} {user.lastName}
          </p>
          <span>{user.roleName}</span>
        </UserInfo>
        <UserStatus>
          <StatusLabel status={user.state}>{user.state}</StatusLabel>
          {
            user.state === 'INVITED' 
            ? 
              <React.Fragment>
                <Tooltip title="Cancel invitation">
                  <Cancel
                    className="share-dialog__delete-btn"
                    onClick={this.deleteInvitation(
                      this.props.companyId,
                      user.id
                    )}
                  />
                </Tooltip>
                <Tooltip title="Send reminder">
                  <MailSharp
                    className="share-dialog__reminder-btn"
                    onClick={this.sendReminder(
                      this.props.companyId,
                      user.id
                    )}
                  />
                </Tooltip>
              </React.Fragment>
            :
              <StatusBtn
                size="small"
                color="secondary"
                disabled={this.state.submitting}
                onClick={this.toggleUserStatus(user.id)}
              >
              {user.state === 'DEACTIVATED' ? 'activate' : 'deactivate'}
            </StatusBtn>
          }
        </UserStatus>
      </User>
    ));

  render() {
    return (
      <Wrapper>
        {this.state.loading ? (
          <CircularProgress size={64} />
        ) : (
          this.renderUsers()
        )}
      </Wrapper>
    );
  }
}
